export const environment = {
  production: true,
  apiUrl: 'https://strapi.admin.jtask.ovh/api/',
  baseUrl: 'https://strapi.admin.jtask.ovh',
};
